import { useUser } from '@clerk/clerk-react';
import React from 'react';

import { useConfigVersionBootstrap } from '@/hooks/useConfigVersionBootstrap';

/**
 * CacheBootstrapProvider
 *
 * 挂在 Clerk + Redux 之内，AuthContext 之外（避免循环依赖）。
 *
 * 职责：Clerk 鉴权完成后调用 `useConfigVersionBootstrap` 完成 IndexedDB 灌注
 * + 版本号校验。
 *
 * **不**承担路由切换时的版本号节流校验 — 那部分由 `<ConfigVersionRevalidator>`
 * 在 Layout 内挂载(必须在 RouterProvider 内,否则 `useLocation` 抛错)。
 *
 * 详见 OpenSpec add-version-based-cache。
 */
export function CacheBootstrapProvider({ children }: { children: React.ReactNode }) {
  const { user, isLoaded } = useUser();

  // tenant_id 从 Clerk publicMetadata 读取（具体 schema 由后端定义）
  const tenantId = React.useMemo<string | null>(() => {
    if (!user) return null;
    const tid = (user.publicMetadata as Record<string, unknown> | undefined)?.tenant_id;
    return tid != null ? String(tid) : null;
  }, [user]);

  const userId = user?.id ?? null;

  useConfigVersionBootstrap({
    userId,
    tenantId,
    enabled: isLoaded && !!user,
  });

  return <>{children}</>;
}
